export default __webpack_public_path__ + "static/media/kanye3.cdb1ce7f.jpeg";